module.exports = __webpack_public_path__ + "img/三星高级大师@2x.4d42bf6a.png";